<template>
  <form class="card-panel" @submit.prevent="confirmAndNext">
    <div class="row">
      <div class="col s12 m6">
        <h5>
          <i class="material-icons">person</i>Evaluador
        </h5>
        Nombre: {{evaluator.name}}
        <br>
        Puesto: {{evaluator.stall}}
        <br>
        Area: {{evaluator.area}}
        <br>

      </div>
      <div class="col s12 m6">
        <h5>
          <i class="material-icons">person</i>Evaluado
        </h5>
        Nombre: {{thisCampain.name}}
        <br>
        Puesto: {{thisCampain.stall}}
        <br>
        Area: {{thisCampain.area}}
        <br>

      </div>
    </div>

    <div class="row">
      <div class="col s12 m6">
        <label class="font-size">Frecuencia de Interacción con el Evaluado</label>
        <div class="input-field">
          <select v-model="frequency" class="browser-default" required>
            <option value disabled selected>Frecuencia de Interacción</option>
            <option value="Autoevaluación">Autoevaluación</option>
            <option value="Ninguna">Ninguna</option>
            <option value="Rara vez">Rara vez</option>
            <option value="Regularmente">Regularmente</option>
            <option value="Siempre">Siempre</option>
          </select>
        </div>
      </div>
      <div class="col s12 m6">
        <label class="font-size">Qué calificación le darías al Evaluado</label>
        <div class="input-field">
          <select v-model="qualification" class="browser-default" required>
            <option value disabled selected>Calificación</option>
            <option value="No satisfactorio">No satisfactorio</option>
            <option value="Poco satisfactorio">Poco satisfactorio</option>
            <option value="Satisfactorio regularmente">Satisfactorio regularmente</option>
            <option value="Satisfactorio">Satisfactorio</option>
            <option value="Muy satisfactorio">Muy satisfactorio</option>
          </select>
        </div>
      </div>
    </div>
    <div class="right-align">
      <button class="btn indigo">
        <i class="material-icons left">send</i>Continuar
      </button>
    </div>
  </form>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      frequency: "",
      qualification: ""
    };
  },
  computed: {
    ...mapState(["evaluator", "thisCampain"])
  },
  methods: {
    confirmAndNext() {
      this.updateFrequency(this.frequency);
      this.updateQualification(this.qualification);
      this.$emit("nextStep");
    },
    ...mapMutations(["updateFrequency", "updateQualification"])
  },
  mounted() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});
  }
};
</script>

<style scoped>
	.font-size {
		font-size: 1rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/questionnaire/questionnaireSteps/info.vue